"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import Tin from "@maplat/tin";
var keys = ["title", "attr", "officialTitle", "dataAttr", "author", "createdAt", "era", "license", "dataLicense", "contributor", "mapper", "reference", "description", "url", "lang", "imageExtension", "homePosition", "mercZoom"];
export function store2HistMap(_x) {
  return _store2HistMap.apply(this, arguments);
}
function _store2HistMap() {
  _store2HistMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(store) {
    var byCompiled,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          byCompiled = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          return _context.abrupt("return", store2HistMap_internal(store, byCompiled, false));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _store2HistMap.apply(this, arguments);
}
export function store2HistMap4Core(_x2) {
  return _store2HistMap4Core.apply(this, arguments);
}
function _store2HistMap4Core() {
  _store2HistMap4Core = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(store) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", store2HistMap_internal(store, false, true));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _store2HistMap4Core.apply(this, arguments);
}
function store2HistMap_internal(_x3, _x4, _x5) {
  return _store2HistMap_internal.apply(this, arguments);
}
function _store2HistMap_internal() {
  _store2HistMap_internal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(store, byCompiled, coreLogic) {
    var ret, tins, opt, tin, _tin, sub_maps, i, sub_map, sub, _opt, _tin2, _tin3;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          ret = coreLogic ? store : {};
          tins = [];
          keys.forEach(function (key) {
            ret[key] = store[key];
          });
          if (store["imageExtention"] || store["imageExtension"]) ret["imageExtension"] = store["imageExtension"] || store["imageExtention"];
          if (!store.compiled) {
            _context3.next = 23;
            break;
          }
          opt = {};
          if (!store.compiled.wh) opt.wh = [store.width, store.height];
          if (!store.compiled.strictMode) opt.strictMode = store.strictMode;
          if (!store.compiled.vertexMode) opt.vertexMode = store.vertexMode;
          if (!store.compiled.yaxisMode) opt.yaxisMode = store.yaxisMode;
          tin = new Tin(opt);
          tin.setCompiled(store.compiled);
          if (byCompiled) {
            tin = tin.getCompiled();
          }
          ret.strictMode = tin.strictMode;
          ret.vertexMode = tin.vertexMode;
          ret.yaxisMode = tin.yaxisMode;
          ret.width = tin.wh[0];
          ret.height = tin.wh[1];
          ret.gcps = tin.points;
          ret.edges = tin.edges;
          tins.push(tin);
          _context3.next = 35;
          break;
        case 23:
          ret.strictMode = store.strictMode;
          ret.vertexMode = store.vertexMode;
          ret.yaxisMode = store.yaxisMode;
          ret.width = store.width;
          ret.height = store.height;
          ret.gcps = store.gcps;
          ret.edges = store.edges;
          _context3.next = 32;
          return createTinFromGcpsAsync(store.strictMode, store.vertexMode, store.yaxisMode, store.gcps, store.edges, [store.width, store.height]);
        case 32:
          _tin = _context3.sent;
          if (byCompiled && typeof _tin !== "string") _tin = _tin.getCompiled();
          tins.push(_tin);
        case 35:
          if (!store.sub_maps) {
            _context3.next = 70;
            break;
          }
          sub_maps = [];
          i = 0;
        case 38:
          if (!(i < store.sub_maps.length)) {
            _context3.next = 69;
            break;
          }
          sub_map = store.sub_maps[i];
          sub = {};
          sub.importance = sub_map.importance;
          sub.priority = sub_map.priority;
          if (!sub_map.compiled) {
            _context3.next = 57;
            break;
          }
          _opt = {};
          if (!sub_map.compiled.strictMode) _opt.strictMode = store.strictMode;
          if (!sub_map.compiled.vertexMode) _opt.vertexMode = store.vertexMode;
          if (!sub_map.compiled.yaxisMode) _opt.yaxisMode = store.yaxisMode;
          _tin2 = new Tin(_opt);
          _tin2.setCompiled(sub_map.compiled);
          if (byCompiled) {
            _tin2 = _tin2.getCompiled();
          }
          sub.bounds = _tin2.bounds;
          sub.gcps = _tin2.points;
          sub.edges = _tin2.edges;
          tins.push(_tin2);
          _context3.next = 65;
          break;
        case 57:
          sub.bounds = sub_map.bounds;
          sub.gcps = sub_map.gcps;
          sub.edges = sub_map.edges;
          _context3.next = 62;
          return createTinFromGcpsAsync(store.strictMode, store.vertexMode, store.yaxisMode, sub_map.gcps, sub_map.edges, undefined, sub_map.bounds);
        case 62:
          _tin3 = _context3.sent;
          if (byCompiled && typeof _tin3 !== "string") _tin3 = _tin3.getCompiled();
          tins.push(_tin3);
        case 65:
          sub_maps.push(sub);
        case 66:
          i++;
          _context3.next = 38;
          break;
        case 69:
          ret.sub_maps = sub_maps;
        case 70:
          return _context3.abrupt("return", [ret, tins]);
        case 71:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _store2HistMap_internal.apply(this, arguments);
}
export function histMap2Store(_x6, _x7) {
  return _histMap2Store.apply(this, arguments);
}
function _histMap2Store() {
  _histMap2Store = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(histmap, tins) {
    var ret, tin;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          ret = {};
          keys.forEach(function (key) {
            ret[key] = histmap[key];
          });
          if (histmap["imageExtention"] || histmap["imageExtension"]) ret["imageExtension"] = histmap["imageExtension"] || histmap["imageExtention"];
          tin = tins.shift();
          if (typeof tin === "string") {
            ret.width = histmap.width;
            ret.height = histmap.height;
            ret.gcps = histmap.gcps;
            ret.edges = histmap.edges;
            ret.strictMode = histmap.strictMode;
            ret.vertexMode = histmap.vertexMode;
            ret.yaxisMode = histmap.yaxisMode;
          } else {
            ret.compiled = tin.getCompiled ? tin.getCompiled() : tin;
          }
          ret.sub_maps = tins.length > 0 ? tins.map(function (tin, index) {
            var sub_map = histmap.sub_maps[index];
            var sub = {
              priority: sub_map.priority,
              importance: sub_map.importance
            };
            if (typeof tin === "string") {
              sub.gcps = sub_map.gcps;
              sub.edges = sub_map.edges;
              sub.bounds = sub_map.bounds;
            } else {
              sub.compiled = tin.getCompiled ? tin.getCompiled() : tin;
            }
            return sub;
          }) : [];
          return _context4.abrupt("return", ret);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _histMap2Store.apply(this, arguments);
}
function createTinFromGcpsAsync(_x8, _x9, _x10) {
  return _createTinFromGcpsAsync.apply(this, arguments);
}
function _createTinFromGcpsAsync() {
  _createTinFromGcpsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(strict, vertex, yaxis) {
    var gcps,
      edges,
      wh,
      bounds,
      tin,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          gcps = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : [];
          edges = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : [];
          wh = _args5.length > 5 ? _args5[5] : undefined;
          bounds = _args5.length > 6 ? _args5[6] : undefined;
          if (!(gcps.length < 3)) {
            _context5.next = 6;
            break;
          }
          return _context5.abrupt("return", "tooLessGcps");
        case 6:
          tin = new Tin({
            yaxisMode: yaxis
          });
          if (!wh) {
            _context5.next = 11;
            break;
          }
          tin.setWh(wh);
          _context5.next = 16;
          break;
        case 11:
          if (!bounds) {
            _context5.next = 15;
            break;
          }
          tin.setBounds(bounds);
          _context5.next = 16;
          break;
        case 15:
          throw "Both wh and bounds are missing";
        case 16:
          tin.setStrictMode(strict);
          tin.setVertexMode(vertex);
          tin.setPoints(gcps);
          tin.setEdges(edges);
          _context5.prev = 20;
          _context5.next = 23;
          return tin.updateTinAsync();
        case 23:
          return _context5.abrupt("return", tin);
        case 26:
          _context5.prev = 26;
          _context5.t0 = _context5["catch"](20);
          console.log(_context5.t0);
          if (!(_context5.t0 == "SOME POINTS OUTSIDE")) {
            _context5.next = 33;
            break;
          }
          return _context5.abrupt("return", "pointsOutside");
        case 33:
          if (!(_context5.t0.indexOf("TOO LINEAR") == 0)) {
            _context5.next = 37;
            break;
          }
          return _context5.abrupt("return", "tooLinear");
        case 37:
          if (!(_context5.t0.indexOf("Vertex indices of edge") > -1 || _context5.t0.indexOf("is degenerate!") > -1 || _context5.t0.indexOf("already exists or intersects with an existing edge!") > -1)) {
            _context5.next = 41;
            break;
          }
          return _context5.abrupt("return", "edgeError");
        case 41:
          throw _context5.t0;
        case 42:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[20, 26]]);
  }));
  return _createTinFromGcpsAsync.apply(this, arguments);
}